import { render, staticRenderFns } from "./TeacherCommonInfo.vue?vue&type=template&id=b7ba23da&scoped=true&"
import script from "./TeacherCommonInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherCommonInfo.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCommonInfo.vue?vue&type=style&index=0&id=b7ba23da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ba23da",
  null
  
)

export default component.exports